var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"id":"prefix__arrow_a","d":"M3.344 0L4.656 0 4.656 9.438 7.063 7.063 8 8 4 12 0 8 0.938 7.063 3.344 9.438z"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(8 6)","key":1},[React.createElement("mask",{"id":"prefix__b_arrow","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#prefix__arrow_a"})),React.createElement("use",{"fill":"currentColor","xlinkHref":"#prefix__arrow_a","key":1}),React.createElement("g",{"fill":"none","mask":"url(#prefix__b_arrow)","key":2},React.createElement("path",{"d":"M0 0H72V72H0z","transform":"translate(-32 -30)"}))])]);
}

ArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
